var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24999 3.74998V26.25C6.25071 26.4778 6.31353 26.7011 6.43171 26.8958C6.54989 27.0906 6.71895 27.2494 6.92068 27.3552C7.12242 27.461 7.34919 27.5098 7.5766 27.4964C7.804 27.4829 8.02342 27.4076 8.21124 27.2787L24.4612 16.0287C25.135 15.5625 25.135 14.44 24.4612 13.9725L8.21124 2.72248C8.02381 2.59227 7.80428 2.5159 7.5765 2.50169C7.34871 2.48748 7.12139 2.53596 6.91923 2.64188C6.71707 2.74779 6.5478 2.90708 6.42981 3.10244C6.31182 3.2978 6.24963 3.52176 6.24999 3.74998ZM21.5537 15L8.74999 23.865V6.13498L21.5537 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b33db7f9d3c6a467b4eee01cb83737dd.svg";
export { ForwardRef as ReactComponent };